import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import Url from '../Url';
import { LoginContext } from './LoginContext';

export default function Login() {
    const [mobilenumber, setMobile] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useContext(LoginContext);

    // STEP 1: Send 
    const handleMobileSubmit = async (e) => {
        e.preventDefault();
        if (!/^\d{10}$/.test(mobilenumber)) {
            setError('Please enter a valid 10-digit mobile number.');
            return;
        }
       
        try {
            const response = await fetch(`${Url.Url}/generate-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ mobilenumber }),
            });

            const data = await response.json();
            console.log('OTP Send Response:', data);
       
            if (response.ok /*&& data.success*/) {
                setShowOtpInput(true);
                setError('');
            //    console.log('OTP sent via SMS');
            } else {
                setError(data.message || 'Failed to send Pin.');
            }
        } catch (err) {
            console.error('Error:', err);
            setError('Server error. Please try again later.');
        }
    };

    // STEP 2: Verify OTP and log in
    const handleOtpSubmit = async (e) => {
        e.preventDefault();

        if (otp.trim() === '') {
            setError('Please enter the Pin.');
            return;
        }

        try {
            const verifyResponse = await fetch(`${Url.Url}/verify-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ mobilenumber: mobilenumber, otp }),
            });

            const verifyResult = await verifyResponse.json();
            console.log('OTP Verify Response:', verifyResponse);
            if (!verifyResponse.ok) {
                setError(verifyResult.message || 'Pin verification failed.');
                return;
            }

            // OTP verified, fetch user data
            const queryData = {
                report_id: 2,
                mobilenumber: mobilenumber,
            };
            console.log('Query Data:', queryData);
            const userResponse = await fetch(
                `${Url.Url}/get_report?data=${encodeURIComponent(JSON.stringify(queryData))}`
            );
            const userResult = await userResponse.json();
            console.log('User Data Response:', userResult, userResponse.ok);
            if (userResponse.ok && Array.isArray(userResult) && userResult.length > 0) {
                const userData = userResult[0]; // no [0][0], just [0]
              
                login(userData);

                if (userData.user_type === 'team_head') {
                    navigate('/Sidebar/Dashboard');
                } else if (userData.user_type === 'team_member') {
                    navigate('/Sidebar/Dashboard_user');
                } else {
                    setError('Unknown user type.');
                }
                console.log('User Data:', userData);
            } else {
                setError('User data not found.');
            }

        } catch (err) {
            console.error('Login error:', err);
            setError('Login failed. Please try again.');
        }
    };
    // const handleOtpSubmit = async (e) => {
    //     e.preventDefault();

    //     if (otp.trim() === '') {
    //         setError('Please enter the OTP.');
    //         return;
    //     }

    //     // Bypass OTP check if the default OTP is used
    //     if (otp.trim() !== '3060') {
    //         setError('Invalid OTP');
    //         return;
    //     }

    //     try {
    //         // Fetch user data directly after default OTP is accepted
    //         const queryData = {
    //             report_id: 2,
    //             mobilenumber: mobilenumber,
    //         };

    //         const userResponse = await fetch(
    //             `${Url.Url}/get_report?data=${encodeURIComponent(JSON.stringify(queryData))}`
    //         );
    //         const userResult = await userResponse.json();

    //         if (userResponse.ok && Array.isArray(userResult[0]) && userResult[0].length > 0) {
    //             const userData = userResult[0][0];
    //             login(userData);

    //             // Navigate based on user type
    //             if (userData.user_type === 'team_head') {
    //                 navigate('/Sidebar/Dashboard');
    //             } else if (userData.user_type === 'team_member') {
    //                 navigate('/Sidebar/Dashboard_user');
    //             } else {
    //                 setError('Unknown user type.');
    //             }
    //         } else {
    //             setError('User data not found.');
    //         }
    //     } catch (err) {
    //         console.error('Login error:', err);
    //         setError('Login failed. Please try again.');
    //     }
    // };
    
    return (
        <div className="login-container">
            <div className="glass-card">
                <div className="logo-container">
                    <img src="/images/auditlogo.png" alt="Logo" className="logo" />
                </div>
                <div className="card-content">
                    <h2 className="title">Auditusierp-CRM Login</h2>

                    {!showOtpInput ? (
                        <form onSubmit={handleMobileSubmit} className="form">
                            <input
                                type="text"
                                placeholder="Enter Mobile Number"
                                value={mobilenumber}
                                onChange={(e) => setMobile(e.target.value)}
                                required
                            />
                            <button type="submit" className="lbutton">Login</button>
                            {error && <p className="error">{error}</p>}
                        </form>
                    ) : (
                        <form onSubmit={handleOtpSubmit} className="form">
                            <input
                                type="password"                     // shows dots instead of numbers
                                placeholder="Enter Pin"
                                value={otp}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only numbers and max length of 4
                                    if (/^\d{0,4}$/.test(value)) {
                                        setOtp(value);
                                    }
                                }}
                                maxLength={4}                       // restricts input to 4 characters
                                inputMode="numeric"                // shows number pad on mobile
                                pattern="\d{4}"                    // enforces 4-digit numeric input on submit
                                required
                            />
                            <button type="submit" className="lbutton">Login</button>
                            {error && <p className="error">{error}</p>}
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
